import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";
import TemplateCard from "../components/TemplateCard";

import yellowtailPreview from "../images/yellowtail.png";
import purplesquidPreview from "../images/purplesquid.png";
import redsnapperPreview from "../images/redsnapper.png";

const DATA = [
  {
    title: 'Yellow Tail',
    description: 'Trusting and friendly.',
    image: yellowtailPreview,
    detailsLink: '/yellowtail',
    demoLink: 'https://yellowtail.netlify.app'
  },
  {
    title: 'Purple Squid',
    description: 'Playful but powerful.',
    image: purplesquidPreview,
    detailsLink: '/purplesquid',
    demoLink: 'https://purplesquid.netlify.app'
  },
  {
    title: 'Red Snapper',
    description: 'Lively and adventurous.',
    image: redsnapperPreview,
    detailsLink: '/redsnapper',
    demoLink: 'https://redsnapper.netlify.app'
  }
]

function TemplatesPage() {
  return (
    <Layout>
      <SEO title="Templates" />
      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16 min-h-screen">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">Templates</h1>
        <div className="flex flex-col md:flex-row items-center justify-evenly mt-10 lg:mt-16">
          {DATA.map((item,index) => (
            <TemplateCard 
              key={index} 
              item={item}
            />
          ))}          
        </div>        
      </section>
    </Layout>
  );
}

export default TemplatesPage;